import { Button } from 'antd';
import { SimpleButtonProps } from './SimpleButton.types';

const SimpleButton = ({
  children,
  htmlType = 'button',
  type,
  size = 'middle',
  loading = false,
  disabled = false,
  icon,
  onClick,
  rounded = false,
  outlined = false,
  name,
  className,
  refElement,
}: SimpleButtonProps) => {
  return (
    <Button
      htmlType={htmlType}
      type={type}
      size={size}
      loading={loading}
      disabled={disabled}
      icon={icon}
      onClick={onClick}
      className={customClass(rounded, outlined, className)}
      name={name}
      ref={refElement}
      onContextMenu={(e) => {
        e.preventDefault();
        return false;
      }}
    >
      {children}
    </Button>
  );
};

const customClass = (rounded: boolean, outlined: boolean, className?: string) => {
  const roundedClass = rounded ? 'curveButtonBorders' : '';
  const outlinedClass = outlined ? 'kfsOutlinedBtn' : 'kfsFilledBtn';
  return roundedClass + ' ' + outlinedClass + ' ' + className;
};
export default SimpleButton;
